import { JtechAxios } from 'src/plugins/axios'

export default {
  donwloadPdf: async function (id) {
    return await JtechAxios.request().get(`/annex-report/pdf/${id}`, {
      responseType: 'blob',
      headers: { Accept: 'application/pdf' }
    })
  }
}
